<div class="bmarkSpotRiskInstrumentContainer">
  <span
    class="bm-instrument-icon-container"
    (mouseenter)="showError($event)"
    (mouseleave)="hide()"
    [style.display]="warningOverlayEnabled ? 'inline-flex': 'none'"
  >
    <i class="icon icon-warning pricingErrorIconFill"></i>
  </span>
  <span class="bm-instrument-label-container">{{instrument}}</span>
  <span
    #valueDateToggle
    class="bm-instrument-icon-container"
    [ngClass]="{'bm-instrument-icon-container': hasFwdOrders,
      'hidden-icon-container': !hasFwdOrders,
    }"
  >
    <bfx-icon-button
      size="sm"
      iconClass="icon_ion_clone_filled"
      (action)="showValueDates($event)"
      title="Show Value Date Totals"
    ></bfx-icon-button>
  </span>
  <!-- Overlay panel for errors only - value date totals handled at blotter level-->
  <p-overlayPanel #op appendTo="body" styleClass="bm-risk-pair-overlay">
    <div class="bm-risk-pair-overlay-title">{{popoutInfo.title}}</div>
    <div *ngFor="let row of popoutInfo.rows" class="warningContent">{{row}}</div>
    <div *ngIf="popoutInfo.total !== null" class="warningTotal">{{popoutInfo.total}}</div>
  </p-overlayPanel>
</div>
